// import appConfig from "../config/app.config";

import { isEmpty } from "lodash";

const ALL = "ALL";
const GOOGLE = googleSDK;
const PIXEL = pixelSDK;
const APPSFLYER = appsflyerSDK;
const MIXPANEL = mixpanelSDK;
const CLEVERTAP = clevertapSDK;

const SDKList = [GOOGLE, PIXEL, MIXPANEL, CLEVERTAP, APPSFLYER];

//SDK functions defination
function googleSDK(eventName, eventValue, sendTo) {
  //sending google event
  let eventData;
  if (sendTo) {
    eventData = Object.assign(
      {
        send_to: sendTo,
      },
      eventValue
    );
  } else {
    eventData = Object.assign(
      {
        send_to: process.env.REACT_APP_GTAG_LOCATION,
      },
      eventValue
    );
  }
  window.gtag("event", eventName, eventData || {});
}

function pixelSDK(eventName, eventValue) {
  //sending pixel event
  window.fbq("trackCustom", eventName, eventValue || {});
}

function appsflyerSDK(eventName, eventValue) {
  //sending appsflyer event
  window.AF("pba", "event", {
    eventType: "EVENT",
    eventName: eventName,
    eventValue: eventValue || {},
  });
}

function mixpanelSDK(eventName, eventValue) {
  window.mixpanel.track(eventName, eventValue || {});
}

function clevertapSDK(eventName, eventValue) {
  window.clevertap.event.push(eventName, eventValue || {});
}

const eventSDKSelector = (eventName, eventValue, SDKOptions, sendTo = null) => {
  try {
    if (SDKOptions === ALL) {
      SDKList.forEach((sdkFunction) => {
        sdkFunction(eventName, eventValue, sendTo);
      });
      return true;
    } else if (SDKOptions.length > 0) {
      SDKOptions.forEach((sdkFunction) => {
        sdkFunction(eventName, eventValue, sendTo);
      });
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const sendEvent = (eventName, obj = {}, sendTo) => {
  try {
    switch (eventName) {
      case "Homepg_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Get_started_clicked":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Signup_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Signup_completed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Bank_link_started":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Bank_link_completed":
        return eventSDKSelector("Web_Bank_link_completed_frontend", obj, ALL);
      case "Web_card_cross_clicked":
        return eventSDKSelector("Web_card_cross_clicked", obj, ALL);

      case "Dwnld_CTA_clicked":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_flow_started":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_flow_completed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_flow_exited":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_bank_selected":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_bank_login_success":
        return eventSDKSelector(eventName, obj, ALL);

      case "CompleteRegistration":
        return eventSDKSelector(eventName, obj, [PIXEL, GOOGLE], sendTo);

      case "conversion":
        return eventSDKSelector(eventName, obj, [GOOGLE], sendTo);

      case "willow_signup_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_signup_completed":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_signup_downloaded":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_cancel_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_cancel_successful":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_cancel_downloaded":
        return eventSDKSelector(eventName, obj, ALL);

      case "add_to_wishlist":
        return eventSDKSelector(eventName, obj, ALL);

      case "generate_lead":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_phone_number_added":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_phone_number_verified":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Bank_link_completed_frontend":
        return eventSDKSelector(eventName, obj, ALL);
      case "Web_card_cross_clicked":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_card_popup_fired":
        return eventSDKSelector(eventName, obj, ALL);

      case "Cricbuzz_phone_number_added":
        return eventSDKSelector(eventName, obj, ALL);

      case "Cricbuzz_phone_number_verified":
        return eventSDKSelector(eventName, obj, ALL);

        case "Cricbuzz_phone_number_screen_landed":
          return eventSDKSelector(eventName, obj, ALL);
      default:
      // console.log("No event selected");
    }
  } catch (error) {
    return error;
  }
};

const setClevertapProfile = (obj) => {
  if (obj) {
    window.clevertap.profile.push({
      Site: obj,
    });
    return true;
  }
  return false;
};

const setMixpanelProfile = (obj) => {
  if (obj) {
    window.mixpanel.people.set(obj);
    return true;
  }
  return false;
};

const setAFCustomerUserId = (id) => {
  window.AF("pba", "setCustomerUserId", String(id));
};

const getUtmSource = () => {
  setUtmData();
  return sessionStorage.getItem("utm_source") || "organic";
};

const getUtmMedium = () => {
  return sessionStorage.getItem("utm_medium") || "";
};

const getUtmCampaign = () => {
  return sessionStorage.getItem("utm_campaign") || "";
};

const setUtmData = () => {
  const windowUrl = new URL(window.location.href);
  const utm_source = windowUrl.searchParams.get("utm_source")
    ? windowUrl.searchParams.get("utm_source")
    : "";
  const utm_medium = windowUrl.searchParams.get("utm_medium")
    ? windowUrl.searchParams.get("utm_medium")
    : "";
  const utm_campaign = windowUrl.searchParams.get("utm_campaign")
    ? windowUrl.searchParams.get("utm_campaign")
    : "";

  const prev_utm_source = sessionStorage.getItem("utm_source");
  const prev_utm_medium = sessionStorage.getItem("utm_medium");
  const prev_utm_campaign = sessionStorage.getItem("utm_campaign");

  if (utm_source === "") {
    if (prev_utm_source === null) {
      sessionStorage.setItem("utm_source", "organic");
    }
  } else {
    sessionStorage.setItem("utm_source", utm_source);
  }

  if (prev_utm_medium === null || utm_medium !== "") {
    sessionStorage.setItem("utm_medium", utm_medium);
  }

  if (prev_utm_campaign === null || utm_campaign !== "") {
    sessionStorage.setItem("utm_campaign", utm_campaign);
  }
};

const Homepg_landed = (obj) => {
  try {
    if (!obj.utm_source) {
      throw new Error("utm_source required");
    }
    return sendEvent("Homepg_landed", {
      utm_source: obj.utm_source,
      utm_medium: obj.utm_medium || "",
      utm_campaign: obj.utm_campaign || "",
    });
  } catch (error) {
    return error;
  }
};

const Get_started_clicked = (obj = {}) => {
  try {
    if (!obj.click_source) {
      throw new Error("click_source required");
    }
    if (!["header", "main", "footer", "login_pg"].includes(obj.click_source)) {
      throw new Error("invalid click_source");
    }

    return sendEvent("Get_started_clicked", {
      click_source: obj.click_source,
      carousel_pos: obj.carousel_pos,
    });
  } catch (error) {
    return error;
  }
};

const Web_Signup_landed = (obj = {}) => {
  try {
    postMparticleEvent({
      eventName: "Web_Signup_landed",
      eventType: ["EVENT", "USER"],
      attributes: obj,
    });
    return sendEvent("Web_Signup_landed", {
      utm_source: obj.utm_source,
      utm_medium: obj.utm_medium,
      utm_campaign: obj.utm_campaign,
      user_source: obj.user_source,
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Web_Signup_completed = (obj = {}) => {
  try {
    // if (!obj.email) {
    //   throw new Error("email required");
    // }
    // if (!obj.signup_source) {
    //   throw new Error("signup_source required");
    // }
    // if (!["web", "ios"].includes(obj.signup_source)) {
    //   throw new Error("invalid signup_source");
    // }
    postMparticleEvent({
      eventName: "Web_Signup_completed",
      eventType: ["EVENT", "USER"],
      attributes: obj,
    });
    return sendEvent("Web_Signup_completed", obj);
  } catch (error) {
    return error;
  }
};

const Add_To_Wishlist = (obj = {}) => {
  try {
    return sendEvent("add_to_wishlist", {
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Generate_Lead = (obj = {}) => {
  try {
    return sendEvent("generate_lead", {
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Web_Bank_link_started = (obj) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }
    if (!obj.type) {
      throw new Error("type required");
    }
    if (!["clo", "plaid"].includes(obj.type)) {
      throw new Error("invalid type");
    }
    return sendEvent("Web_Bank_link_started", {
      type: obj.type,
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Web_Bank_link_completed = (obj = {}) => {
  try {
    if (!obj.web_bank_linked) {
      throw new Error("web_bank_linked required");
    }
    if (![true, false].includes(obj.web_bank_linked)) {
      throw new Error("invalid web_bank_linked");
    }
    if (!obj.email) {
      throw new Error("email required");
    }
    if (!obj.type) {
      throw new Error("type required");
    }
    if (!["clo", "plaid"].includes(obj.type)) {
      throw new Error("invalid type");
    }

    return sendEvent("Web_Bank_link_completed", {
      web_bank_linked: obj.web_bank_linked,
      no_of_active_banks: obj.no_of_active_banks || 0,
      utm_source: obj.utm_source,
      utm_medium: obj.utm_medium,
      utm_campaign: obj.utm_campaign,
      type: obj.type,
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Conversion = (obj = {}) => {
  try {
    return sendEvent(
      "conversion",
      {
        value: obj.value,
        currency: obj.currency,
        transaction_id: obj.transaction_id,
      },
      "AW-658129294/BC5TCL3z8ocYEI6D6bkC"
    );
  } catch (error) {
    return error;
  }
};

const HQUserSignup = () => {
  try {
    return sendEvent("conversion", null, "AW-658129294/y1ldCOy3h6gYEI6D6bkC");
  } catch (error) {
    return error;
  }
};

const HQUserBankAdd = (obj = {}) => {
  try {
    return sendEvent(
      "conversion",
      {
        transaction_id: obj.transaction_id,
      },
      "AW-658129294/7rUtCP3z_acYEI6D6bkC"
    );
  } catch (error) {
    return error;
  }
};

const Dwnld_CTA_clicked = (obj = {}) => {
  try {
    if (!obj.platform_selected) {
      throw new Error("platform_selected required");
    }
    if (!["iOS", "Android"].includes(obj.platform_selected)) {
      throw new Error("invalid platform_selected");
    }
    return sendEvent("Dwnld_CTA_clicked", {
      platform_selected: obj.platform_selected,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_flow_started = (obj = {}) => {
  try {
    return sendEvent("Plaid_flow_started");
  } catch (error) {
    return error;
  }
};

const Plaid_flow_completed = (obj = {}) => {
  try {
    if (!obj.bank_name) {
      throw new Error("bank_name required");
    }

    return sendEvent("Plaid_flow_completed", {
      bank_name: obj.bank_name,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_flow_exited = (obj = {}) => {
  try {
    // if (!obj.bank_name) {
    //   throw new Error("bank_name required");
    // }

    // if (!obj.exit_screen) {
    //   throw new Error("exit_screen required");
    // }

    if (!obj.status) {
      throw new Error("status required");
    }

    return sendEvent("Plaid_flow_exited", {
      bank_name: obj.bank_name,
      exit_screen: obj.exit_screen,
      error_code: obj.error_code || null,
      status: obj.status,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_bank_selected = (obj = {}) => {
  try {
    if (!obj.bank_name) {
      throw new Error("bank_name required");
    }

    return sendEvent("Plaid_bank_selected", {
      bank_name: obj.bank_name,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_bank_login_success = (obj = {}) => {
  try {
    if (!obj.bank_name) {
      throw new Error("bank_name required");
    }

    return sendEvent("Plaid_bank_login_success", {
      bank_name: obj.bank_name,
    });
  } catch (error) {
    return error;
  }
};

const CompleteRegistration = (obj = {}) => {
  try {
    return sendEvent(
      "CompleteRegistration",
      null,
      "AW-658129294/JRfiCNbu8ocYEI6D6bkC"
    );
  } catch (error) {
    return error;
  }
};

const getAFUserId = () => {
  return document.cookie
    .split(";")
    .filter((p) => p.includes("afUserId"))[0]
    .split("=")[1];
};

const willow_signup_landed = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }

    return sendEvent("willow_signup_landed", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_signup_completed = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }
    return sendEvent("willow_signup_completed", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_signup_downloaded = (obj = {}) => {
  try {
    if (!obj.platform_selected) {
      throw new Error("platform_selected required");
    }
    if (!["ios", "android", "email"].includes(obj.platform_selected)) {
      throw new Error("invalid platform_selected");
    }

    return sendEvent("willow_signup_downloaded", {
      platform_selected: obj.platform_selected,
    });
  } catch (error) {
    return error;
  }
};

const willow_cancel_landed = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }

    return sendEvent("willow_cancel_landed", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_cancel_successful = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }
    return sendEvent("willow_cancel_successful", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_cancel_downloaded = (obj = {}) => {
  try {
    if (!obj.platform_selected) {
      throw new Error("platform_selected required");
    }
    if (!["ios", "android", "email"].includes(obj.platform_selected)) {
      throw new Error("invalid platform_selected");
    }

    return sendEvent("willow_cancel_downloaded", {
      platform_selected: obj.platform_selected,
    });
  } catch (error) {
    return error;
  }
};

const addDeleteUserAttributes = (type = "ADD", attributes) => {
  const currentUser = window?.mParticle?.Identity?.getCurrentUser();
  if (!isEmpty(attributes)) {
    for (let key in attributes) {
      if (type === "ADD") {
        currentUser.setUserAttribute(key, attributes[key]);
      }
      if (type === "DELETE") {
        currentUser.removeUserAttribute(key, attributes[key]);
      }
    }
  }
  return;
};

const postMparticleEvent = ({ eventName, eventType, attributes }) => {
  try {
    const hasUserAttributes = eventType?.some(
      (eventType) => eventType === "USER"
    );
    if (hasUserAttributes) {
      addDeleteUserAttributes("ADD", attributes);
    }
    window?.mParticle?.logEvent(
      eventName,
      window?.mParticle.EventType.Transaction,
      attributes
    );
    // if (hasUserAttributes) {
    //   addDeleteUserAttributes("DELETE", attributes);
    // }
  } catch (error) {
    console.log("Failed to post mparticle events.");
    return error;
  }
};

const Web_phone_number_added = (obj = {}) => {
  try {
    return sendEvent("Web_phone_number_added", obj);
  } catch (error) {
    return error;
  }
};

const Web_phone_number_verified = (obj = {}) => {
  try {
    return sendEvent("Web_phone_number_verified", obj);
  } catch (error) {
    return error;
  }
};

const Web_card_popup_fired = (obj = {}) => {
  try {
    return sendEvent("Web_card_popup_fired");
  } catch (error) {
    return error;
  }
};

const Web_Bank_link_completed_frontend = (obj = {}) => {
  try {
    return sendEvent("Web_Bank_link_completed_frontend", obj);
  } catch (error) {
    return error;
  }
};

const Web_card_cross_clicked = (obj = {}) => {
  try {
    return sendEvent("Web_card_cross_clicked");
  } catch (error) {
    return error;
  }
};

const Cricbuzz_phone_number_added = (obj = {}) => {
  try {
    if (!obj.phone_number) {
      throw new Error("Phone Number required");
    }
    return sendEvent("Cricbuzz_phone_number_added", {
      email:obj.email,
      phone_number: obj.phone_number,
      subscription_plan: obj.subscription_plan,
    });
  } catch (error) {
    return error;
  }
};
const Cricbuzz_phone_number_verified = (obj = {}) => {
  try {
    if (!obj.phone_number) {
      throw new Error("Phone Number required");
    }

    return sendEvent("Cricbuzz_phone_number_verified", {
      email: obj.email,
      phone_number: obj.phone_number,
      subscription_plan: obj.subscription_plan,
    });
  } catch (error) {
    return error;
  }
};

const Cricbuzz_phone_number_screen_landed = (obj = {}) => {
  try {
    return sendEvent("Cricbuzz_phone_number_screen_landed", {
      email: obj.email,
      subscription_plan: obj.subscription_plan,
    });
  } catch (error) {
    return error;
  }
};

export {
  setUtmData,
  sendEvent,
  setAFCustomerUserId,
  setClevertapProfile,
  setMixpanelProfile,
  getAFUserId,
  getUtmSource,
  getUtmMedium,
  getUtmCampaign,
  Homepg_landed,
  Get_started_clicked,
  Web_Signup_landed,
  Web_Signup_completed,
  Web_Bank_link_started,
  Web_Bank_link_completed,
  Web_Bank_link_completed_frontend,
  Web_phone_number_added,
  Web_phone_number_verified,
  Web_card_popup_fired,
  Dwnld_CTA_clicked,
  Plaid_flow_started,
  Plaid_flow_completed,
  Plaid_flow_exited,
  Plaid_bank_selected,
  Plaid_bank_login_success,
  CompleteRegistration,
  Conversion,
  willow_signup_landed,
  willow_signup_completed,
  willow_signup_downloaded,
  willow_cancel_landed,
  willow_cancel_successful,
  willow_cancel_downloaded,
  HQUserSignup,
  HQUserBankAdd,
  Add_To_Wishlist,
  Generate_Lead,
  postMparticleEvent,
  Web_card_cross_clicked,
  Cricbuzz_phone_number_added,
  Cricbuzz_phone_number_verified,
  Cricbuzz_phone_number_screen_landed
};
